module.exports = __webpack_public_path__ + "static/media/home-bg-responsive.9912f2cd.png";